import {
  extend,
  localize,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate/dist/vee-validate.esm'
/* eslint-disable camelcase */
import {
  alpha_spaces,
  confirmed,
  email,
  min,
  numeric,
  required,

} from 'vee-validate/dist/rules'

import pt_BR from 'vee-validate/dist/locale/pt_BR.json'

import Vue from 'vue'

function onlyNumbers (value) {
  return value.replace(/\D/g, '')
}

function hasDuplicates (value) {
  return (new Set(onlyNumbers(value).split(''))).size === 1
}

const regexPhone = /^\([1-9]{2}\) (?:[2-8]|9[0-9])[0-9]{3}-[0-9]{4}$/

export const injectVeeValidate = ({
  extend,
  localize,
  ValidationObserver,
  ValidationProvider,
}) => {
// https://github.com/quero-edu/zilla/blob/3ab79bcbd30a86f062748dfa3d45c9cd4ca10c76/packages/zilla-vue/src/molecules/z-input-field/error.json
  const zillaErrors = {
    messages: {
      between: 'Precisa ser entre {min} e {max}',
      confirmed: 'As informações precisam estar iguais',
      email: 'Parece que este e-mail está incorreto',
      max: 'O limite máximo é de {length} caracteres',
      max_value: 'Precisa ser menor que {max}',
      min: 'O mínimo é {length} caracteres',
      min_value: 'Precisa ser maior que {min}',
      numeric: 'Por favor, coloque um número válido',
      required: 'Você precisa preencher esse campo',
      required_if: 'Você precisa preencher esse campo',
    },
  }

  extend('alpha_spaces', alpha_spaces)
  extend('confirmed', confirmed)
  extend('email', email)
  extend('min', min)
  extend('numeric', numeric)
  extend('required', required)

  extend('phone_number', (value) => {
    if (!value || !value.length || (!hasDuplicates(value.slice(5)) && regexPhone.test(value))) return true

    return 'Parece que o número está errado'
  })

  localize({
    pt_BR: {
      ...pt_BR,
      names: {
        age: 'idade',
        location: 'cidade',
        'user.name': 'nome',
        'user.cpf': 'CPF',
        'user.rg': 'RG',
        'user.document_expeditor': 'orgão expedidor',
        'user.birthday': 'data de nascimento',
        'user.email': 'email',
        'user.phone': 'celular',
        'user.postal_code': 'cep',
        'user.state': 'estado',
        'user.city': 'cidade',
        'user.address': 'endereço',
        'user.address_number': 'número',
        'user.neighborhood': 'bairro',
        'user.enem_number': 'número do enem',
        'user.enem_natureza': 'ciências da natureza',
        'user.enem_humanas': 'ciências humanas',
        'user.enem_linguagens': 'linguagens',
        'user.enem_matematica': 'matemática',
        'user.enem_redacao': 'redação',
        'user.document': 'rg',
        salary: 'salário',
      },
      messages: {
        ...pt_BR.messages,
        ...zillaErrors.messages,
        cpf: 'Verifique se você digitou o CPF corretamente',
        date: 'Parece que a data está errada',
        birthday: 'Parece que a data está errada',
        full_name: 'Digite seu nome completo',
        min: 'Precisa ser maior que {length} caracteres',
        phone_number: 'Parece que o {_field_} está errado',
        postal_code: 'Parece que o CEP está errado',
        enem_number: 'Coloque um número de inscrição válido',
      },
      fields: {
        email: {
          email: 'Parece que este e-mail está incorreto.',
        },
      },
    },
  })

  localize('pt_BR')

  Vue.component('ValidationObserver', ValidationObserver)
  Vue.component('ValidationProvider', ValidationProvider)
}

injectVeeValidate({
  extend,
  localize,
  ValidationObserver,
  ValidationProvider,
})
